<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item
        v-for="(item, index) in pageMeta.breadcrumb"
        :key="index"
      >
        <router-link :to="{ name: item.name }">{{ item.title }}</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>{{ pageMeta.title }}</el-breadcrumb-item>
    </el-breadcrumb>
    <h1 class="view-head">
      {{pageMeta.title}}
    </h1>
    <div class="view-content">
      <el-card class="box-card">
        <div class="table-tool">共{{totalCount}}条</div>
        <el-table
          v-loading="loading"
          :data="tableData"
          style="width: 100%">
          <el-table-column
            prop="create_time"
            label="时间"
            width="170">
          </el-table-column>
          <el-table-column
            prop="email_title"
            label="邮件主题">
          </el-table-column>
          <el-table-column
            prop="file_name"
            label="附件名称">
          </el-table-column>
          <el-table-column
            prop="broker_name"
            label="发件方">
            <template slot-scope="scope" v-if="scope.row.email_type != -4">
              <span>{{scope.row.broker_name?scope.row.broker_name:scope.row.email_address}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="email_type"
            label="处理结果"
            width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.email_type == 1">成功</span>
              <span v-if="scope.row.email_type != 1">失败</span>
            </template>
          </el-table-column>
          <el-table-column
            label="原因">
            <template slot-scope="scope">
              <span v-if="scope.row.email_type == 2">发件人未与商业公司匹配</span>
              <span v-if="scope.row.email_type == 3">文件名无法判定数据类型</span>
              <span v-if="scope.row.email_type == -1">文件格式不正确</span>
              <span v-if="scope.row.email_type == -2">没有附件</span>
              <span v-if="scope.row.email_type == -3">其他错误</span>
              <span v-if="scope.row.email_type == -4">企业邮箱密码错误，请联系工作人员</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-if="totalPage>1">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="20"
            layout="prev, pager, next, jumper"
            :total="totalCount">
          </el-pagination>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
  import { emailLogList } from '@/api/index';
  export default {
    name: "MailFetchingManage",
    beforeCreate() {
      this.pageMeta = this.$route.meta;
      this.email_client_id = this.$route.params.id;
    },
    created(){
      this.getList(1);
    },
    data: () => ({
      tableData:[],
      currentPage: 1,
      totalCount: 0,
      totalPage: 0,
      loading: false,
    }),
    methods:{
      getList(page){
        this.loading = true;
        emailLogList(page).then(res=>{
          this.loading = false;
          if (0 === res.status) {
            this.tableData = res.data.list
            this.totalCount = res.data.totalCount;
            this.currentPage = parseInt(res.data.currentPage);
            this.totalPage = res.data.totalPage;
          } else {
            this.tableData = [];
            this.currentPage = 1;
            this.totalCount = 0;
            this.totalPage = 0;
          }
        });
      },
      handleCurrentChange(val){
        console.log(val)
        this.getList(val);
      }
    }
  }
</script>

<style scoped lang="less">

</style>